__turbopack_context__.v({
  "column": "InlineTextSection-module-scss-module__W7W-EW__column",
  "inlineTextSection": "InlineTextSection-module-scss-module__W7W-EW__inlineTextSection",
  "text": "InlineTextSection-module-scss-module__W7W-EW__text",
  "title": "InlineTextSection-module-scss-module__W7W-EW__title",
});
